<template>
  <section id="doctors">
    <div class="bg-secondary pt-16 pb-10">
      <text-h2 class="text-white text-center">Meet Dr Kazmi</text-h2>
      <section-container>
        <div class="flex justify-center items-center flex-col">
          <img
            class="object-contain h-[450px] w-[750px] rounded-md mt-10"
            src="/images/drkazmi.jpg"
            width="750"
            height="450"
          />
        </div>
        <div class="flex justify-center pt-4">
          <ul
            role="list"
            class="mt-3 grid grid-cols-2 gap-8 sm:grid-cols-4 sm:gap-12 max-w-4xl"
          >
            <li
              v-for="credential in credentials"
              :key="credential.name"
              class="col-span-1 flex justify-center"
            >
              <div class="flex items-center justify-center">
                <img :src="credential.logo" :alt="credential.name" class="w-24 md:w-20 h-auto object-contain" />
              </div>
            </li>
          </ul>
        </div>
        <div class="text-white mt-10 flex justify-center pb-10">
          <div class="max-w-4xl">
            <div>
              <text-h4>About Dr Kazmi</text-h4>
              <div class="space-y-4 text-white">
                <p>
                  Dr. M.Mehdi Kazmi is double-board certified in psychiatry and neurology. He trained in both specialties at Montefiore Medical Center, Albert Einstein College of Medicine.
                </p>
                <p>
                  He is one of the founders of Regional Neurological Associates and has been in practice since 1995 in New York. In addition to general psychiatry and neurology, his interests in psychiatry include mood disorders, anxiety disorders and neuropsychiatry.
                </p>
                <p>
                  He accepts a wide variety of insurance plans and is able to see new patients within a week at our Bronx and Yonkers offices.
                </p>
                <p>
                  He was included in the Best Doctors in New York listing in 1997, early in his practice years. He is fluent in Urdu, Hindi, Punjabi and Arabic.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section-container>
    </div>
    
    <!-- Other Clinicians Section -->
    <div class="bg-secondary pt-16 pb-10">
      <text-h2 class="text-white text-center text-2xl mb-12">Other Clinicians</text-h2>
      <section-container>
        <div class="grid md:grid-cols-2 gap-12">
          <!-- Dr. Berliner -->
          <div class="bg-white rounded-lg shadow-lg p-8">
            <div class="flex flex-col items-center text-center">
              <img 
                src="https://regionalneurological.com/wp-content/uploads/2018/12/IMG_2137-200x300.jpg" 
                alt="Dr. Berliner" 
                class="w-48 h-60 object-cover rounded-lg mb-6"
              />
              <h3 class="text-2xl font-bold text-gray-900 mb-4">Randall Berliner, MD</h3>
              <div class="text-left space-y-4 text-gray-700">
                <p>
                  Dr. Berliner completed a dual residency program in neurology and psychiatry at Albert Einstein College of Medicine; where he then went on to complete a research fellowship in Geriatric Neuropsychiatry under the supervision of Dr. Richard Lipton. It was during that time that he developed his interest in headaches, one that he has pursued to this day.
                </p>
                <p>
                  Dr. Berliner is an active member of the American Headache Society, and specializes in interventional approaches to Migraines and other headache disorders, including Botox, infusions, and other injections. He has published in this area including on Nerve Blocks and the role of the Sphenopalatine Ganglion in headache.
                </p>
                <p>
                  His other areas of interest include Vestibular Migraine (vertigo in migraine), anxiety and depression in headache disorders, and anxiety and depression in general. Dr. Berliner is also very comfortable with general neurology and psychiatry and sees many patients with memory disorders and ADHD as well.
                </p>
                <p class="font-semibold">
                  Dr. Berliner is Board Certified in Neurology, Psychiatry and Headache Medicine, and is a Fellow of the American Headache Society.
                </p>
              </div>
            </div>
          </div>
          
          <!-- Nabila Al-barghouthy, P.A. -->
          <div class="bg-white rounded-lg shadow-lg p-8">
            <div class="flex flex-col items-center text-center">
              <img 
                src="https://regionalneurological.com/wp-content/uploads/2021/10/Nabila-pic-543x1024.jpg" 
                alt="Nabila Al-barghouthy, P.A." 
                class="w-48 h-60 object-cover rounded-lg mb-6"
              />
              <h3 class="text-2xl font-bold text-gray-900 mb-4">Nabila Al-barghouthy, P.A.</h3>
              <div class="text-left space-y-4 text-gray-700">
                <p>
                  Nabila Al-barghouthy graduated from Augsburg University in 2002, Cum Laude in Physician Assistant Studies, completing her M.S/Pa Studies from University of Nebraska, and is in her dissertation phase of her PhD studies in Healthcare Leadership & Patient Advocacy.
                </p>
                <p>
                  She is a Physician Assistant, with 22 years of clinical experience, Certified through the National Commission on Certification of Physician Assistants (NCCPA), now specializing in Internal Medicine at Montefiore Medical Center, Albert Einstein School of Medicine at the Wakefield Campus.
                </p>
                <p>
                  In addition to general neurology, she has extensive training as senior surgical renal PA with comprehensive treatment of renal hemodialysis patients in in-patient dialysis care. Nabila's experience also includes Family Medicine at the University of Minnesota, Boynton Health Services, and treating patients in autonomous collaboration in a primary care setting.
                </p>
                <p>
                  She has worked as adjunct academic professor for Augsburg University teaching variety of subjects in the Physician Assistant Medical Program. Nabila joined Regional Neurological Team in 2020 and is well versed in treating the wide variety of neurological conditions.
                </p>
                <p class="font-semibold">
                  She is fluent in Arabic, has a passion for neurology, listening to patients, their concerns and optimizing their care.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section-container>
    </div>
  </section>
</template>

<script setup>
import stjr from "~/assets/images/credentials/stjr.png";
import sjmc from "~/assets/images/credentials/sjmc.png";
import mont from "~/assets/images/credentials/mont.png";
import ein from "~/assets/images/credentials/ein.png";

const credentials = [
  {
    name: "St. Joseph's Regional Medical Center",
    logo: stjr,
  },
  {
    name: "St. Joseph's Medical Center",
    logo: sjmc,
  },
  {
    name: "Montefiore Medical Center",
    logo: mont,
  },
  {
    name: "Albert Einstein College of Medicine",
    logo: ein,
  },
];
</script>
